import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "snt-page-detail-header-badge",
  template: "",
  standalone: false
})
export class PageDetailHeaderBadgeComponent {
  @Input() title: string = "";
  @Input() cssClass: string = "";

  @Output() onClick: EventEmitter<void> = new EventEmitter();
}
